import React from 'react';
import { View } from 'react-native';
import BrandIcon from '../../icons/BrandIcon';
import styles from './styles';
import { useTheme } from '@hmsexp/component-library';

const BlockingLoader = () => {
  const theme = useTheme();
  return (
    <View style={[styles.blockingLoader, { backgroundColor: theme.palette.background }]}>
      <BrandIcon />
    </View>
  );
};

export default BlockingLoader;
